import React from "react";

import IconCheckbox from "../IconCheckbox";
import StoryFilterChip from "./StoryFilterChip";
import StorySheet from "./StorySheet";
import { getStoryLevelDot, pluralizeTexts, STORY_LEVELS, STORY_SORTS, STORY_SOURCES, STORY_STATUSES } from "./storyLibrary";

export default function StoryFiltersSheet({ filters, sort, sourceCounts, topics, visibleCount, onClear, onClose, onSort, onToggle }) {
  const chipGroups = [
    { group: "statuses", options: STORY_STATUSES, title: "Status" },
    { group: "levels", options: STORY_LEVELS, title: "Level" },
    { group: "topics", options: topics, title: "Topic" }
  ];

  return (
    <StorySheet
      footer={
        <>
          <button className="btn btn-default btn-lg joystix" data-testid="story-filters-clear" type="button" onClick={onClear}>Clear all</button>
          <button className="btn btn-success btn-lg joystix story-sheet-primary" data-testid="story-filters-show" type="button" onClick={onClose}>
            Show {pluralizeTexts(visibleCount)}
          </button>
        </>
      }
      testId="story-filters-sheet"
      title="Filters"
      onClose={onClose}
    >
      <section className="story-sheet-section">
        <h3>Show texts from</h3>
        {STORY_SOURCES.map((source) => (
          <IconCheckbox
            checked={filters.sources.includes(source.id)}
            className="story-source-option"
            key={source.id}
            testId={`story-filter-source-${source.id}`}
            onChange={() => onToggle("sources", source.id)}
          >
            <span className="story-source-label">{source.label}</span>
            <span className="story-source-count">{sourceCounts[source.id]}</span>
          </IconCheckbox>
        ))}
      </section>
      <section className="story-sheet-section">
        <h3>Sort</h3>
        <div className="story-chips">
          {STORY_SORTS.map((option) => (
            <StoryFilterChip
              isSelected={sort === option.id}
              key={option.id}
              label={option.label}
              testId={`story-sort-${option.id}`}
              onClick={() => onSort(option.id)}
            />
          ))}
        </div>
      </section>
      {chipGroups
        .filter(({ options }) => options.length > 0)
        .map(({ group, options, title }) => (
          <section className="story-sheet-section" key={group}>
            <h3>{title}</h3>
            <div className="story-chips">
              {options.map((option) => (
                <StoryFilterChip
                  emoji={option.emoji}
                  isSelected={filters[group].includes(option.id)}
                  key={option.id}
                  label={option.label}
                  levelId={group === "levels" ? getStoryLevelDot(option.id) : undefined}
                  testId={`story-filter-${group}-${option.id}`}
                  onClick={() => onToggle(group, option.id)}
                />
              ))}
            </div>
          </section>
        ))}
    </StorySheet>
  );
}
